export default function loadMorePress() {
    const button = document.querySelector(".js-load-more-press");
    if (!button) return;

    // dipendenze globali dal vecchio codice (restano uguali)
    const ajaxUrl = window.FSR_AJAX?.ajax;
    const nonce = window.FSR_AJAX?.nonce;
    if (!ajaxUrl || !nonce) {
        console.warn("FSR_AJAX.ajax non definito");
        return;
    }

    button.addEventListener("click", async (e) => {
        e.preventDefault();

        if (typeof window.current_page_alfa === "undefined") {
            console.warn("current_page_alfa non definito");
            return;
        }

        const nextPage = window.current_page_alfa + 1;

        const data = new URLSearchParams();
        data.append("action", "loadmorepress");
        data.append("nonce", nonce);
        data.append("page", String(nextPage));

        // UI loading
        const oldHtml = button.innerHTML;
        button.textContent = "Loading...";
        button.setAttribute("aria-busy", "true");
        button.classList.add("is-loading");

        try {
            const res = await fetch(ajaxUrl, {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
                body: data.toString(),
                credentials: "same-origin",
            });

            const raw = await res.text();

            let response;
            try {
                response = JSON.parse(raw);
            } catch (e) {
                console.error("Risposta NON JSON dal server. Ecco i primi 300 char:\n", raw.slice(0, 300));
                throw e;
            }

            if (response?.data) {
                const list = document.querySelector("#Press .Press__list");
                if (!list) {
                    console.warn("Container '#Press .Press__list' non trovato");
                    return;
                }

                list.insertAdjacentHTML("beforeend", response.data);

                // ripristina bottone
                button.innerHTML = '<i class="fa fa-arrow-down mr-2"></i> Load More';

                // aggiorna pagina corrente
                if (typeof response.current_page !== "undefined") {
                    window.current_page_alfa = response.current_page;
                } else {
                    window.current_page_alfa = nextPage;
                }

                // se ultima pagina, rimuovi bottone
                if (
                    typeof response.max_pages !== "undefined" &&
                    window.current_page_alfa >= response.max_pages
                ) {
                    button.remove();
                }
            } else {
                // niente contenuti -> rimuovi bottone
                button.remove();
            }
        } catch (err) {
            console.error("loadMorePress error:", err);
            // fallback UI
            button.innerHTML = oldHtml;
        } finally {
            button.removeAttribute("aria-busy");
            button.classList.remove("is-loading");
        }
    });
}
